// @flow

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { css } from 'glamor'
import glamorous from 'glamorous'

import { BodyText, HeadingText, Button } from '@paypalcorp/pp-react'

import InitialDialog from './initial-dialog'
import CoverPan from './cover-pan'

// content
import getContent from 'pp-react-l10n'
const l10n = getContent('pages/seller/photos')

const PageContainer = glamorous.div({
  position: 'relative',
  height: '50vh',
})

const ButtonContainer = glamorous.div({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%,0%)',
  bottom: '-30%',
  '@media(max-width: 414px)': {
    width: '100%',
    bottom: '-40%',
  },
})

function PhotosUpload(props) {
  const {
    sellerProfileState: {
      state: {
        photoSettings: {
          hasSeenDialog,
          cachedDataProfilePhoto,
          isCoverDraggable,
        } = {},
      } = {},
    } = {},
  } = props

  // This takes care of the user clicks back case, and
  // then we could be stuck in the cover dragging true state
  const isDraggable = props.history.action === 'POP' ? false : isCoverDraggable

  const hasCachedProfilePhoto = !!cachedDataProfilePhoto

  const [showDialog, setShowDialog] = useState(false)

  const showDialogRef = React.useRef(showDialog)
  showDialogRef.current = showDialog

  useEffect(() => {
    let timer
    if (!hasSeenDialog) {
      timer = setTimeout(() => {
        setShowDialog(true)
      }, 500)
    } else {
      setShowDialog(false)
      clearTimeout(timer)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [])

  // The CTA has a two different possibile routes AND three different
  // content depending on the 'state' of the user's photo upload journey
  const renderContinueCTA = () => {
    let routeToString = '/seller/preview',
      content = '',
      onClick = () => {}

    if (isDraggable) {
      if (hasCachedProfilePhoto) {
        // Save and Preview Profile
        content = l10n('saveAndPreview')
        onClick = () => {
          props.sellerProfileState.updateCachedCoverPhoto()
        }
      } else {
        // Save (we don't have a profile photo)
        content = l10n('saveCover')
        onClick = () => {
          props.sellerProfileState.updateCachedCoverPhoto()
        }
        routeToString = '/seller/photos'
      }
    } else {
      // default
      content = l10n('previewProfile')
    }

    return (
      <ButtonContainer>
        <Button
          className={`${css({
            '@media(max-width: 414px)': { width: '100%' },
          })}`}
          as={Link}
          to={routeToString}
          onClick={onClick}
        >
          {content}
        </Button>
      </ButtonContainer>
    )
  }

  return (
    <PageContainer>
      <InitialDialog
        {...props}
        onClose={() => {
          props.sellerProfileState.updatePhotoSettings({ hasSeenDialog: true })
        }}
        isOpen={showDialogRef.current}
        onCancelButton={() => {
          setShowDialog(!showDialog)
        }}
      />
      <HeadingText size="md">{l10n('heading')}</HeadingText>
      <BodyText
        className={`${css({ marginTop: '1rem', marginBottom: '3rem' })}`}
      >
        {l10n('body')}
      </BodyText>
      <CoverPan
        {...props}
        isDraggable={isDraggable}
        isEditable={!isDraggable}
      />
      {renderContinueCTA()}
    </PageContainer>
  )
}

export default PhotosUpload
